import { render, staticRenderFns } from "./MemoryGymComp.vue?vue&type=template&id=1a55428c&scoped=true"
import script from "./MemoryGymComp.vue?vue&type=script&lang=js"
export * from "./MemoryGymComp.vue?vue&type=script&lang=js"
import style0 from "./MemoryGymComp.vue?vue&type=style&index=0&id=1a55428c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a55428c",
  null
  
)

/* custom blocks */
import block0 from "./MemoryGymComp.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports